import React, { ReactNode } from 'react';
import styles from './link-list.module.scss';

type Props = {
  children: ReactNode;
};

export const LinkList: React.FC<Props> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};
